import { arrayMove } from "@dnd-kit/sortable";

import { ISponsor } from "@src/types/api";

import { useAppDispatch } from "@hooks/reduxHooks";

import {
    globalActions,
    selectSponsor,
} from "@/app/src/features/global/globalSlice";

const useAdvertisers = (
    setSponsors: React.Dispatch<React.SetStateAction<ISponsor[]>>,
) => {
    const dispatch = useAppDispatch();

    const handleDragEnd = (event: any) => {
        const { active, over } = event;

        if (active.id !== over.id) {
            setSponsors(items => {
                const oldIndex = items.findIndex(item => item.id === active.id);
                const newIndex = items.findIndex(item => item.id === over.id);
                const newOrder = arrayMove(items, oldIndex, newIndex);

                const sortOrderData = newOrder.map((sponsor, index) => ({
                    id: sponsor.id,
                    sortOrder: index + 1,
                }));

                dispatch(globalActions.updateSponsorOrder(sortOrderData));

                return newOrder;
            });
        }
    };

    return { handleDragEnd };
};

export default useAdvertisers;
